// Stackly Office agent portrait generator (v1). Deterministic: the same agent name always gives the same face.
// The Floor page uses the same palette and hash, so an agent looks the same everywhere.
// Usage (React): const ref = useRef(); useEffect(() => { ref.current.replaceChildren(agentPortrait({name, department, status, prop}, 40)); }, [...]);
const SKIN = ['#f1c9a5','#e0ac85','#c68b62','#a06a45','#7a4b2e','#5b3820'];
const HAIR = ['#1f1a17','#3b2a1e','#6b4226','#a8692e','#d8b26a','#b8b8b8','#8c2f1d','#2b2b3a'];
const STYLES = ['short','long','bun','bald','curly','cap','side','spiky'];
export const DEPT_COLOR = { 'CEO Office':'#64748b', 'Product Studio':'#3f6cf0', 'IT':'#1aa39a', 'Marketing':'#ea7a2f', 'Social Studio':'#2EB8EF', 'AFG Dubai':'#244494', 'Sales':'#3aa35b', 'Finance':'#d9a21b', 'Legal':'#6b4fd0' };
export function hashName(s){let h=2166136261;for(const ch of s){h^=ch.charCodeAt(0);h=Math.imul(h,16777619);}return h>>>0;}
export function agentPortrait(agent, size = 40) {
  const c = document.createElement('canvas'); c.width = 14; c.height = 14;
  c.style.width = size + 'px'; c.style.height = size + 'px'; c.style.imageRendering = 'pixelated';
  const x = c.getContext('2d'), h = hashName(agent.name);
  const L = { skin: SKIN[h % 6], hair: HAIR[(h >> 3) % 8], style: STYLES[(h >> 6) % 8], glasses: ((h >> 12) % 3) === 0 };
  const r = (px, py, w, hh, col) => { x.fillStyle = col; x.fillRect(px, py, w, hh); };
  r(0, 0, 14, 14, '#16233a');
  r(3, 11, 8, 3, DEPT_COLOR[agent.department] || '#3f6cf0'); r(6, 11, 2, 1, 'rgba(255,255,255,.35)');
  r(5, 10, 4, 1, L.skin);
  const hy = 4; r(4, hy, 6, 6, L.skin);
  r(5, hy + 3, 1, 1, '#1b1b1b'); r(8, hy + 3, 1, 1, '#1b1b1b');
  if (L.glasses) { r(4, hy + 3, 3, 1, '#111'); r(7, hy + 3, 3, 1, '#111'); }
  r(6, hy + 5, 2, 1, '#9b5a4a');
  const hc = L.hair;
  switch (L.style) {
    case 'short': r(4, hy - 1, 6, 2, hc); r(4, hy + 1, 1, 1, hc); r(9, hy + 1, 1, 1, hc); break;
    case 'long': r(4, hy - 1, 6, 2, hc); r(3, hy, 1, 7, hc); r(10, hy, 1, 7, hc); break;
    case 'bun': r(4, hy - 1, 6, 2, hc); r(6, hy - 3, 2, 2, hc); break;
    case 'bald': r(3, hy + 2, 1, 2, hc); r(10, hy + 2, 1, 2, hc); break;
    case 'curly': r(3, hy - 2, 8, 3, hc); r(3, hy + 1, 1, 2, hc); r(10, hy + 1, 1, 2, hc); break;
    case 'cap': r(4, hy - 1, 6, 2, '#d63b3b'); r(3, hy + 1, 4, 1, '#a82a2a'); break;
    case 'side': r(4, hy - 1, 6, 1, hc); r(4, hy, 4, 1, hc); r(3, hy, 1, 5, hc); break;
    case 'spiky': r(4, hy - 1, 6, 1, hc); r(4, hy - 2, 1, 1, hc); r(6, hy - 2, 1, 1, hc); r(8, hy - 2, 1, 1, hc); break;
  }
  if (agent.prop === 'headset') { r(3, hy + 2, 1, 3, '#222'); r(10, hy + 2, 1, 3, '#222'); r(4, hy - 1, 6, 1, '#222'); }
  if (agent.status === 'offline') c.style.opacity = .45;
  return c;
}
